<template>
  <div class="block">
    <label>{{ title }}</label>
    <div class="block-picker" :class="[isChecked?'check':'']">
      <el-date-picker
          v-model="value"
          type="daterange"
          unlink-panels
          range-separator="-"
          :start-placeholder="startTime"
          :end-placeholder="endTime"
          :shortcuts="shortcuts"
          :default-value="defaultValue"
          :disabled="checked"
          :clearable="false"
          value-format="YYYY-MM-DD"
          @change="postTime"
          style="width:100%; flex:1;"
      >
      </el-date-picker>
      <el-checkbox
          v-model="checked"
          :checked="isChecked"
          @change="noTime()"
          style="margin-left: 8px; width: 4.6em"
          :disabled="disable"
      >
        不限
      </el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
name: "date-picker",
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '时间：'
    },
    isChecked: {
      type: Boolean,
      default: true,
    },
    isAddOneDay:{
      type: Boolean,
      default: true
    },
    startTime:{
      type: String,
      default: function() {
        let d = new Date();
        d.setDate(d.getDate()-365);
        return d.getFullYear()+"-"+(d.getMonth()+1 < 10?'0'+(d.getMonth()+1):d.getMonth()+1)+"-"+(d.getDate() < 10?'0'+d.getDate():d.getDate());
      }
    },
    endTime:{
      type: String,
      default: function() {
        let d = new Date();
        d.setDate(d.getDate());
        return d.getFullYear()+"-"+(d.getMonth()+1 < 10?'0'+(d.getMonth()+1):d.getMonth()+1)+"-"+(d.getDate() < 10?'0'+d.getDate():d.getDate());
      }
    },
    shortcuts: {
      type: Array,
      default: function () {
        return [
          {
            text: '最近一周',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              return [start, end]
            },
          },
          {
            text: '最近一个月',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              return [start, end]
            },
          },
          {
            text: '最近三个月',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              return [start, end]
            },
          },
          {
            text: '上一周',
            value: () => {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() - 3600 * 1000 * 24 * (end.getDay()))
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (start.getDay() + 6))
              return [start, end]
            },
          },
          {
            text: '上一个月',
            value: () => {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() - 3600 * 1000 * 24 * (end.getDate()))
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * (start.getDay() + 6))
              const startTime = start.getFullYear()+"-"+(start.getMonth() < 10?'0'+start.getMonth():start.getMonth())+"-01";
              return [startTime, end]
            },
          },
          {
            text: '上三个月',
            value: () => {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() - 3600 * 1000 * 24 * (end.getDate()))
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * (start.getDay() + 6))
              let startTime = ''
              if(start.getMonth()-2 > 0) {
                startTime = start.getFullYear()+"-"+(start.getMonth()-2 < 10?'0'+(start.getMonth()-2):(start.getMonth()-2))+"-01";
              }else {
                startTime = (start.getFullYear()-1)+"-"+(start.getMonth()+12-2 < 10?'0'+(start.getMonth()+12-2):(start.getMonth()+12-2))+"-01";
              }
              return [startTime, end]
            },
          },
        ]
      }
    }
  },
  data() {
    return {
      checked: this.isChecked,
      value: [],
      defaultValue: new Date(),
    }
  },
  watch: {
    isChecked() {
      this.checked = this.isChecked
      this.value[0] = this.startTime;
      this.value[1] = this.endTime;
      if(!this.checked) {
        // this.$emit('date', [this.value[0],this.addOneDay(this.value[1])]);
        this.$emit('date', [this.value[0],this.value[1]]);
      } else {
        this.$emit('date', [null, null]);
      }
    }
  },
  methods: {
    postTime() {
      // this.$emit('date', [this.value[0],this.addOneDay(this.value[1])]);
      this.$emit('date', [this.value[0],this.value[1]]);
    },
    noTime() {
      if(this.checked){
        this.$emit('date', [null, null]);
      }else{
        // this.$emit('date', [this.value[0],this.addOneDay(this.value[1])]);
        this.$emit('date', [this.value[0],this.value[1]]);
      }
      this.$emit('check', this.checked)
    },
    //结束日期加一
    addOneDay(day) {
      let d = new Date(day);
      if(this.isAddOneDay) {
        d.setDate(d.getDate()+1);
      } else {
        d.setDate(d.getDate());
      }
      return d.getFullYear()+"-"+(d.getMonth()+1 < 10?'0'+(d.getMonth()+1):d.getMonth()+1)+"-"+(d.getDate() < 10?'0'+d.getDate():d.getDate());
    }
  },
  created() {
    this.value[0] = this.startTime;
    this.value[1] = this.endTime;
    if(!this.checked) {
      // this.$emit('date', [this.value[0],this.addOneDay(this.value[1])]);
      this.$emit('date', [this.value[0],this.value[1]]);
    } else {
      this.$emit('date', [null, null]);
    }

  }
}
</script>

<style scoped>
.block {
  display: flex;
  align-items: center;
}
.block-picker {
  display: flex;
  flex: 1;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.check {
  /*background-color: #f5f7fa;*/
}

</style>
